import _ from "lodash";
import DailyMenuOptionOrder from "@/model/dailymenu/DailyMenuOptionOrder";

export default class MenuGroupItemOrder {
  private constructor (
    readonly id:string,
    readonly name: string,
    readonly kind: string,
    readonly subGroupList: MenuGroupItemOrder[],
    readonly optionList: DailyMenuOptionOrder[],
    readonly tags: any[]
  ) {}

  get selectedOption (): DailyMenuOptionOrder | undefined {
    return _.find(this.optionList,(option:DailyMenuOptionOrder) => {
      return option.isSelected
    } )

   }


  get isMenuGroupOffered (): boolean {

    let isOffered = true
    let group = this

    if (group.subGroupList.length > 0) {
      group.subGroupList.forEach((subgroup: MenuGroupItemOrder) => {
        if (subgroup.optionList.length > 0) {
          subgroup.optionList.forEach((option: DailyMenuOptionOrder) => {

            if(!option.offer)
              isOffered = false
          })
        }
      })
    }

    if (group.optionList.length > 0) {
      group.optionList.forEach((option: DailyMenuOptionOrder) => {
        if(!option.offer)
          isOffered = false
      })
    }

    return isOffered
  }

  static createFromList (responseData: any[]): MenuGroupItemOrder[] {
    return responseData.map( (value:any):MenuGroupItemOrder => MenuGroupItemOrder.createDailyMenuInterface(value))
  }

  static createDailyMenuInterface (responseData: any): MenuGroupItemOrder {
    return new MenuGroupItemOrder(
      responseData.id,
      responseData.name,
      responseData.kind,
      responseData.subGroups ? MenuGroupItemOrder.createFromList(responseData.subGroups):[],
        responseData.slots ? DailyMenuOptionOrder.createFromResponse(responseData.slots):[],
        responseData.tags
    )
  }
}
